<template>
	<v-pagination
		:value="value"
		:length="length"
		v-bind="$attrs"
		v-on="unhandled_events"
		@input="on_input"
	>
		<slot></slot>
	</v-pagination>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		value: {
			type: Number,
			default: 1,
		},
		length: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		unhandled_events() {
			const { input, ...listeners } = this.$listeners;
			return listeners;
		},
	},
	methods: {
		on_input(value) {
			this.$emit('input', value);
		},
	},
};
</script>
